
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'ProstateCancer_TNM',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/DS/ProstateCancer_TNM.vue